import { FC } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { Button } from 'ui/components/Buttons'
import { IconName } from 'ui/components/Icon'
import { Link } from 'ui/components/Link'
import { useCTRApprove, useCTRCancel } from '~bank-bsa-reporting/hooks/ctr'
import { CTR_DETAILS_KEY } from '~bank-bsa-reporting/hooks/ctr/useGetCTRDetails'

import { s } from './styles'

type Props = {
  id: number
  nextId?: number
  previousId?: number
  showApprove: boolean
  showCancel: boolean
}

const routeApi = getRouteApi('/_app/bsa/ctrs/$id')

export const Footer: FC<Props> = (props) => {
  const { id, nextId, previousId, showApprove, showCancel } = props
  const queryClient = useQueryClient()
  const navigate = routeApi.useNavigate()

  const onSuccessMutation = async () => {
    await queryClient.invalidateQueries({ queryKey: [CTR_DETAILS_KEY] })
  }

  const onErrorMutation = () => navigate({ to: './edit' })

  const { mutate: approveCTR, isPending: isApproving } = useCTRApprove(onSuccessMutation, onErrorMutation)
  const { mutate: cancelCTR, isPending: isCanceling } = useCTRCancel(onSuccessMutation, onErrorMutation)

  return (
    <s.Box>
      <Link to="/bsa/ctrs">
        <Button face="secondary">Go Back to List</Button>
      </Link>
      <s.Right>
        {previousId ? (
          <Link to="/bsa/ctrs/$id" params={{ id: previousId.toString() }}>
            <s.IconButton face="secondary">
              <s.StyledIcon name={IconName.ARROW_PREVIOUS} /> Prev CTR
            </s.IconButton>
          </Link>
        ) : (
          <span />
        )}
        {!!nextId && (
          <Link to="/bsa/ctrs/$id" params={{ id: nextId.toString() }}>
            <s.IconButton face="secondary">
              <s.StyledIcon name={IconName.ARROW_NEXT} /> Next CTR
            </s.IconButton>
          </Link>
        )}
        {showCancel && (
          <Button face="secondary" loading={isApproving || isCanceling} onClick={() => cancelCTR({ id })}>
            Cancel CTR
          </Button>
        )}
        {showApprove && (
          <Button loading={isApproving || isCanceling} onClick={() => approveCTR({ id })} face="primary">
            Approve CTR
          </Button>
        )}
      </s.Right>
    </s.Box>
  )
}
